export enum LocaleCode {
  en = "en",
  ko = "ko",
  ja = "ja",
}

export const languages: {
  id: LocaleCode;
  name: string;
}[] = [
  {
    id: LocaleCode.en,
    name: "English",
  },
  {
    id: LocaleCode.ja,
    name: "Japanese",
  },
  {
    id: LocaleCode.ko,
    name: "Korean",
  },
];

export type Translations = {
  [language in LocaleCode]?: {
    [key: string]: string;
  };
};
